<b-modal v-model="modal_requirement_151" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <!-- ヘッダー -->
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <!-- 文言表示 -->
  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="w-100">
          <div class="box-margin-right work-support-message" style="white-space: break-spaces;">{{ workSupportMessage }}
          </div>
          <div v-if="phase === 'factoryModeDisplay'">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
              <b-form-select class="form-control" v-model="selectedMode" :options="modeListForFactory"
                :select-size="3"></b-form-select>
            </div>
          </div>
          <div v-if="phase === 'dealerModeDisplay'">
            <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
              <b-form-select class="form-control" v-model="selectedMode" :options="modeListForDealer"
                :select-size="2"></b-form-select>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <!-- フッター -->
  <template v-slot:footer>
    <div class="w-100 text-center ">
      <b-button v-if="showButtonCancel" size="sm" :disabled="isDisabledCancel" variant="outline-primary"
        @click="onCancelClicked" class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" :disabled="isDisabledOk" variant="primary" @click="onOkClicked"
        class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>